var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import DynamicButton from "../../DynamicButton";
//modules
import ControladorCantidadEnCarrito from "./components/ControladorCantidadEnCarrito/ControladorCantidadEnCarrito";
import IconoEnCarrito from "../../../modules/iconoEnCarrito";
import TipoDeEnvio from "./components/TipoDeEnvio";
import Promocion from "./components/Promocion";
import ContadorHotSale from "./components/ContadorHotSale/ContadorHotSale";
import EstrellasCalificacion from "../../EstrellasCalificacion";
import ListsControl from "./components/ListsControl/ListsControl";
import ListaDeOpcionesDeCanJeOca from "../../ListaDeOpcionesDeCanJeOca";
import { quitarProductoDeLista } from "../../../redux/data/listadoProductos";
import { agregarQuitarProductoALista } from "../../../redux/data/listas";
import { useAppDispatch, useAppSelector, } from "../../../hooks/customReduxHooks";
import LoadstoneService from "../../../redux/services/loadstone";
import { faTrash } from "@fortawesome/pro-light-svg-icons";
import IndicadorHotSale from "./components/IndicadorHotSale";
import IconoRecomendadoDermatologos from "./components/IconoRecomendadoDermatologos";
import ImagenProducto from "./components/ImagenProducto/ImagenProducto";
import FechaAgregadoEnLista from "./components/FechaAgregadoEnLista";
import TituloProducto from "./components/TituloProducto";
//import VariacionesProducto from "./components/VariacionesProductos";
import NombreFabricanteProducto from "./components/NombreFabricanteProducto";
import PrecioProducto from "./components/PrecioProducto/PrecioProducto";
import FechaDisponibilidadProducto from "./components/FechaDisponibilidadProducto";
import { calcularTiempoTranscurrido } from "../../../helpers/dateHelper";
import { Tags } from "./components/Tags";
import { AvisoDescuentoConTransferencia, AvisoMoviendoItem, CantidadProductosRestantes, ContainerInfoAndOptions, ContenedorGrupoDeAcciones, ContenedorInfoDeArticulo, GrupoPrecioHotSale, GrupoPrecioyOferta, HotSaleProductDisabled, InformacionDePrecios, OpcionesDeArticuloEnLista, PrecioOff, SelectMoverALista, StyledInfoCantidadComentarioYPrioridad, StyledProducto, TituloYFabricante, TextoUltimaVisualizacion, ProductFooterData, } from "./TarjetaProductoStyled";
var TarjetaProducto = function (_a) {
    var _b, _c;
    var contextoVisual = _a.contextoVisual, producto = _a.producto, keyId = _a.keyId, _d = _a.esPublica, esPublica = _d === void 0 ? false : _d, _e = _a.listsControlActive, listsControlActive = _e === void 0 ? true : _e, _f = _a.permisoEditarLista, permisoEditarLista = _f === void 0 ? false : _f, styles = _a.styles, _g = _a.hasSubtitle, hasSubtitle = _g === void 0 ? true : _g, eliminarTarjeta = _a.eliminarTarjeta, _h = _a.hideTags, hideTags = _h === void 0 ? false : _h, _j = _a.mostrarBotonAgregarAlCarrito, mostrarBotonAgregarAlCarrito = _j === void 0 ? true : _j;
    var dispatch = useAppDispatch();
    //Solo se trae listas de usuario si el listControl no esta activo.
    var listasUsuario = !listsControlActive
        ? useAppSelector(function (state) { return state.listas.listasDeUsuario; })
        : [];
    var listaId = useAppSelector(function (state) {
        var _a, _b, _c;
        return (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.listadoColeccionSlice) === null || _a === void 0 ? void 0 : _a.datosListadoDeProductos) === null || _b === void 0 ? void 0 : _b.listaInformacion) === null || _c === void 0 ? void 0 : _c.id;
    });
    var componentes = useAppSelector(function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.empresa) === null || _a === void 0 ? void 0 : _a.empresaData) === null || _b === void 0 ? void 0 : _b.componentes; });
    var estaEnCarrito = useAppSelector(function (state) {
        var _a, _b, _c;
        return ((_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.carrito) === null || _a === void 0 ? void 0 : _a.productosEnCarrito) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.id === producto.id; })) === null || _c === void 0 ? void 0 : _c.cantidad) > 0;
    });
    var enviosDisponibles = useAppSelector(function (state) { return state.empresa && state.empresa.enviosDisponibles; });
    var globalConfig = useAppSelector(function (state) { return state.empresa && state.empresa.globalConfig; });
    var _k = useState(true), desactivarContador = _k[0], setDesactivarContador = _k[1]; // es para el hotsale
    var _l = useState(false), productDisabled = _l[0], setProductDisabled = _l[1]; // es para el hotsale de la home
    var _m = useState(false), cargandoMoverProductoLista = _m[0], setCargandoMoverProductoLista = _m[1]; // es para el hotsale
    //esta funcion se utiliza al cerrar el modal para actualizar el estado con la respuesta de la API
    var MouseDownRetailRocket = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var loadstoneData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!producto.vitrinaLoadStone) return [3 /*break*/, 2];
                    e.preventDefault();
                    return [4 /*yield*/, LoadstoneService.postLoadstone({
                            productId: producto.id,
                            recomBlockId: producto.recomBlockId,
                            type: "recomTap",
                        })];
                case 1:
                    loadstoneData = _a.sent();
                    if (loadstoneData.status === "success") {
                        window.location.href = producto.urlseo;
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var HandleBorrarProductoDeLista = function (listaId, productoId) {
        return new Promise(function (resolve, reject) {
            dispatch(agregarQuitarProductoALista({
                lista_id: listaId,
                producto_id: productoId,
                agregarProducto: 0,
            })).then(function () {
                dispatch(quitarProductoDeLista(productoId));
                resolve(true);
            });
        });
    };
    useEffect(function () {
        if (eliminarTarjeta &&
            contextoVisual !== "historial" &&
            !desactivarContador) {
            eliminarTarjeta(producto.id);
        }
        else if (contextoVisual === "hotSale" && !desactivarContador) {
            setProductDisabled(true);
        }
    }, [desactivarContador]);
    return (React.createElement(StyledProducto, { key: keyId, contextoVisual: contextoVisual, style: styles, className: "productCard", disabled: productDisabled },
        contextoVisual === "historial" && (React.createElement(TextoUltimaVisualizacion, null, calcularTiempoTranscurrido(producto.historial_fecha))),
        estaEnCarrito &&
            contextoVisual &&
            contextoVisual === "lista-personalizada-publica" && React.createElement(IconoEnCarrito, null),
        listsControlActive && (React.createElement(ListsControl, { producto: producto, contexto: contextoVisual !== "slide" && contextoVisual !== "metodos-de-pago" && contextoVisual !== "chinaDeals"
                ? contextoVisual
                : null })),
        componentes &&
            componentes.TARJETA_ARTICULO_NOMBRE_FABRICANTE &&
            ((_b = producto.fabricante) === null || _b === void 0 ? void 0 : _b.recomendadoDermatologos) && (React.createElement(IconoRecomendadoDermatologos, null)),
        React.createElement(ImagenProducto, { producto: producto, onClick: MouseDownRetailRocket, contextoVisual: contextoVisual }, producto.datos_oferta.oferta &&
            (desactivarContador || productDisabled) && (React.createElement(React.Fragment, null,
            React.createElement(IndicadorHotSale, { activo: ((_c = producto === null || producto === void 0 ? void 0 : producto.datos_oferta) === null || _c === void 0 ? void 0 : _c.oferta) && contextoVisual !== "hotSale", desactivarContador: desactivarContador }),
            contextoVisual !== "lista-personalizada-privada" && (React.createElement(ContadorHotSale, { finalFormateado: producto.datos_oferta.oferta.final_formateado, setDesactivarContador: setDesactivarContador, contextoVisual: contextoVisual }))))),
        React.createElement(ContainerInfoAndOptions, { contextoVisual: contextoVisual, className: "containerInfoAndOptions" },
            React.createElement(ContenedorInfoDeArticulo, { contextoVisual: contextoVisual, id: "container-info-producto-react" },
                !hideTags && contextoVisual !== "lista-personalizada-privada" && (React.createElement(Tags, { product: producto })),
                contextoVisual === "lista-personalizada-privada" && (React.createElement(FechaAgregadoEnLista, { producto: producto })),
                !producto.opcionesDeCanjeOca && (React.createElement(InformacionDePrecios, { contextoVisual: contextoVisual },
                    producto.tiene_descuento_transferencia &&
                        contextoVisual !== "metodos-de-pago" && (React.createElement(AvisoDescuentoConTransferencia, null,
                        React.createElement("b", null,
                            producto.moneda,
                            producto.data_descuento_transferencia
                                .precio_final_formateado),
                        React.createElement("span", null, "Transferencia o Dep\u00F3sito"))),
                    contextoVisual === "metodos-de-pago" &&
                        producto.descuento_por_medio_de_pago
                            .length > 0 && (React.createElement(AvisoDescuentoConTransferencia, null,
                        React.createElement("b", null,
                            producto.moneda,
                            " ",
                            producto
                                .descuento_por_medio_de_pago[0]
                                .precio_final_formateado),
                        React.createElement("span", null, producto
                            .descuento_por_medio_de_pago[0].pmed_nombre))),
                    contextoVisual !== "metodos-de-pago" && (React.createElement(React.Fragment, null,
                        React.createElement(GrupoPrecioyOferta, null, !producto.datos_oferta.oferta ||
                            !desactivarContador ||
                            contextoVisual === "hotSale" ? (React.createElement(React.Fragment, null,
                            React.createElement(PrecioProducto, { moneda: producto.moneda, precio: producto.precio, variante: contextoVisual === "hotSale"
                                    ? contextoVisual
                                    : "common" }),
                            producto.precio_mercado &&
                                contextoVisual !== "historial" && (React.createElement(PrecioProducto, { variante: "mercado", moneda: producto.moneda, precio: producto.precio_mercado })))) : (desactivarContador && (React.createElement(GrupoPrecioHotSale, null,
                            React.createElement(PrecioProducto, { moneda: producto.moneda, precio: producto.precio, variante: "mercado" }),
                            React.createElement(PrecioProducto, { variante: "hotSale", moneda: producto.moneda, precio: producto.datos_oferta.precio_final_formateado }))))),
                        !producto.datos_oferta.oferta || !desactivarContador
                            ? producto.precio_mercado && (React.createElement(PrecioOff, null,
                                "- ",
                                producto.porcentaje_descuento,
                                "%"))
                            : desactivarContador && (React.createElement(PrecioOff, null,
                                "- ",
                                producto.datos_oferta.porcentaje_descuento,
                                "%")))))),
                ![
                    "lista-personalizada-privada",
                    "historial",
                    "top10",
                    "metodos-de-pago",
                ].includes(contextoVisual) &&
                    !producto.tiene_descuento_transferencia && (React.createElement(Promocion, { producto: producto })),
                React.createElement(TituloYFabricante, { contextoVisual: contextoVisual },
                    (componentes === null || componentes === void 0 ? void 0 : componentes.TARJETA_ARTICULO_NOMBRE_FABRICANTE) &&
                        (producto === null || producto === void 0 ? void 0 : producto.fabricante) && (React.createElement(NombreFabricanteProducto, { nombre: producto.fabricante.nombre })),
                    React.createElement(TituloProducto, { titulo: producto.titulo, subtitulo: hasSubtitle ? producto.subtitulo : "", url: producto.urlseo, onClick: MouseDownRetailRocket, contextoVisual: contextoVisual })),
                ![
                    "lista-personalizada-privada",
                    "historial",
                    "metodos-de-pago",
                ].includes(contextoVisual) && (React.createElement(ProductFooterData, null,
                    React.createElement(EstrellasCalificacion, { calificaciones: producto.calificaciones }),
                    React.createElement(TipoDeEnvio, { enviosDisponibles: enviosDisponibles, producto: producto }))),
                contextoVisual === "hotSale" &&
                    !producto.descuento_por_medio_de_pago && (React.createElement(CantidadProductosRestantes, null,
                    "\u00A1Solo quedan ",
                    producto.stock,
                    "!")),
                producto.producto_no_disponible && (React.createElement(FechaDisponibilidadProducto, { fecha: producto.fecha_disponibilidad_display })),
                (producto.comentario ||
                    producto.prioridadNombre ||
                    producto.cantidad) && (React.createElement(StyledInfoCantidadComentarioYPrioridad, null,
                    producto.cantidad && (React.createElement("p", null,
                        React.createElement("b", null, "Cantidad:"),
                        " ",
                        producto.cantidad)),
                    producto.comentario && (React.createElement("p", null,
                        React.createElement("b", null, "Comentario:"),
                        " ",
                        producto.comentario)),
                    producto.prioridadNombre &&
                        producto.prioridad !== "3" && (React.createElement("p", null,
                        React.createElement("b", null, "Prioridad:"),
                        " ",
                        producto.prioridadNombre))))),
            React.createElement(ContenedorGrupoDeAcciones, null,
                producto.opcionesDeCanjeOca && (
                /* informacion sobre el canje oca */
                React.createElement(ListaDeOpcionesDeCanJeOca, { producto: producto })),
                mostrarBotonAgregarAlCarrito && (React.createElement(ControladorCantidadEnCarrito, { producto: producto, contextoVisual: contextoVisual })),
                contextoVisual === "lista-personalizada-privada" &&
                    !esPublica && ( //Solo se muestra si contexto es listas personalizada y si no es listado publico.
                React.createElement(OpcionesDeArticuloEnLista, null,
                    React.createElement("div", null,
                        cargandoMoverProductoLista ? (React.createElement(AvisoMoviendoItem, null, "Moviendo...")) : (listasUsuario &&
                            listasUsuario.length > 1 && (React.createElement(SelectMoverALista, { name: "mover-listas-usuario", id: "mover-listas-usuario", onChange: function (e) {
                                setCargandoMoverProductoLista(true);
                                var idListaDestino = e.target.value;
                                HandleBorrarProductoDeLista(listaId, producto.id).then(function (value) {
                                    return dispatch(agregarQuitarProductoALista({
                                        lista_id: idListaDestino,
                                        producto_id: producto.id,
                                        agregarProducto: 1,
                                    }));
                                });
                            } },
                            React.createElement("option", { value: 0 }, "Mover a..."),
                            listasUsuario.map(function (lista) {
                                return lista.id != listaId && ( //Solo mostramos las listas que son distintas a la lista actual.
                                React.createElement("option", { key: lista.id, value: lista.id }, lista.titulo));
                            })))),
                        permisoEditarLista && (React.createElement(DynamicButton, { "aria-label": "Borrar", implicitAction: "inert", text: "Quitar", size: "medium", iconName: faTrash, onClick: function () {
                                return HandleBorrarProductoDeLista(listaId, producto.id);
                            } }))),
                    permisoEditarLista && (React.createElement(DynamicButton, { "aria-label": "Comentarios, cantidad y prioridad", implicitAction: "inert", text: "Comentarios, cantidad y prioridad", size: "medium", marginless: true, onClick: function () {
                            //@ts-ignore
                            return mostrarModalInfoProductoEnLista(listaId, producto);
                        } })))),
                contextoVisual === "historial" && (React.createElement(DynamicButton, { "aria-label": "Borrar", implicitAction: "inert", text: "Quitar", size: "medium", iconName: faTrash, onClick: eliminarTarjeta })))),
        contextoVisual === "hotSale" && productDisabled && (React.createElement(HotSaleProductDisabled, null, "Esta Oferta ".concat(globalConfig.hotSale.textoHotSale, " ha finalizado")))));
};
export default TarjetaProducto;
